import { GetUserToken, useAuth } from 'components/AuthProvider';
import { Prefecture_Enum } from 'generated/graphql';
import { GraphQLError } from 'graphql-request/dist/types';
import { getClientSdk } from 'graphql/client';
import { QueryConfig, TypedQueryFunction, useQuery } from 'react-query';

export const PrefKey = 'prefectures';

export type Prefecture = { value: Prefecture_Enum; name: string };

const getPrefectures = (
  getUserToken: GetUserToken
): TypedQueryFunction<Prefecture[], [typeof PrefKey]> => async (key) => {
  const token = await getUserToken();

  const data = await getClientSdk(token).Prefectures();

  return data.prefecture.map((p) => ({
    name: p.name,
    value: p.value as Prefecture_Enum,
  }));
};

const usePrefectures = (
  options?: QueryConfig<Prefecture[], GraphQLError[]>
) => {
  const { getUserToken } = useAuth();

  return useQuery(PrefKey, getPrefectures(getUserToken), {
    ...options,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};

export default usePrefectures;
